<template>
  <div>
    <spacer :y="5"/>
    <loader-simple :flag="flag.loader">
      <div v-if="!flag.invalid && information">
        <contents-box :title="information.title" icon="<i class='fa-regular fa-bullhorn'></i>">
          <label-box
            :label="filterMoment(information.updated_at, 'YYYY-MM-DD')"
            size="sm"
            color="gray"
            :class="`${$style.label} ${$style.date}`" />

          <spacer :y="4"/>
          <div
            class="n2br"
            :class="$style.content">
            <p v-html="trimTagWhitespace(information.content)"></p>
          </div>

          <spacer :y="5" />
          <btn-container>
            <basic-btn
              to="/schoolInformation/">一覧</basic-btn>
          </btn-container>
        </contents-box>
      </div>

      <div v-else-if="flag.invalid">
        <contents-box title="閲覧できません">
          <div>URLが無効であるか、{{ helper.master && helper.master.labels && user.school ? helper.master.labels.organizationNews[user.school[0].is_company] : (user.school && user.school.length ? (user.school[0].is_company ? '企業レター' : '学校だより') : '学校だより・企業レター') }}を閲覧する権限を持ちません。</div>
        </contents-box>
      </div>
    </loader-simple>
    <spacer :y="5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'schoolinformation-detail',
  mixins: [cf],
  components: {
    BasicBtn,
    BtnContainer,
    ContentsBox,
    LabelBox,
    Spacer,
    LoaderSimple,
  },
  data() {
    return {
      flag: {
        loader: true,
        invalid: false,
      },
      id: null,
      information: null,
      prefix: '',
    };
  },
  computed: {
    ...mapState(['user', 'helper']),
  },
  created() {
    if (this.$route.params
      && this.$route.params.id
      && cf.convert2Num(this.$route.params.id)) {
      this.id = cf.convert2Num(this.$route.params.id);

      if (this.user.email) {
        this.getSchoolInformations();
      } else {
        this.$store.subscribe((mutation) => {
          if (mutation.type === 'user/setUserData') {
            this.getSchoolInformations();
          }
        });
      }
    } else {
      this.flag.loader = false;
      this.flag.invalid = true;
    }
  },
  methods: {
    /** 学校だより取得 */
    getSchoolInformations() {
      this.axios({
        method: 'GET',
        url: '/v1/schoolinformation/get/detail',
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.information = response.data.schoolinformation;
          if (this.user.school[0].id !== this.information.school.id // 学校が違う場合は閲覧不可
            || ![1, 3, 11, 12, 31].includes(this.user.account_type)) { // 生徒・教職員・学校管理者・事務局管理者以外は閲覧不可
            this.flag.invalid = true;
            return false;
          }
          if (!this.user.readflags.schoolInformations.includes(this.information.id)) this.registReadFlag();
          // パンくず
          const breadcrumb = {
            label: this.information.title,
            link: this.$route.fullPath,
          };
          this.$store.dispatch('page/breadcrumbs/addSingleName', breadcrumb, { root: true });
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.flag.invalid = true;
        })
        .finally(() => {
          this.flag.loader = false;
        });
    },
    registReadFlag() {
      const data = {
        model_type: 2, // 事務局からのお知らせ
        user_id: this.user.id,
        foreign_id: this.information.id,
      };
      this.axios({
        method: 'POST',
        url: '/v1/readflag/set/register',
        data,
      })
        .then(() => {
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module>
.date {
  font-size: 12px;
}
.link {
  color: var(--black);
}
.label {
  width: auto;
  display: inline-block;
}
.flex {
  display: flex;
  align-items: flex-start;

  @include sm-view {
    display: block;
  }
}
.content {
  line-height: 2;
  * {
    word-wrap: break-word;
    word-break: break-all;
  }
  a {
    color: var(--black);
    text-decoration: underline;
    transition: all .4s;
    &:hover {
      opacity: .7;
    }
  }
  ol {
    counter-reset: num;
    > li {
      position: relative;
      padding-left: 1.4em;
      &:before {
        counter-increment: num;
        content: counter(num)".";
        position: absolute;
        top: 0; left: 0;
      }
    }
  }
  ul {
    > li {
      position: relative;
      padding-left: 1.4em;
      &:before {
        content: "・";
        position: absolute;
        top: 0; left: 0;
      }
    }
  }
}

</style>
